import React from 'react'
import {FormattedMessage} from 'react-intl'

// no props - just runs inflation
const Inflation = () => <FormattedMessage id="operation.inflation" />

export default Inflation



// WEBPACK FOOTER //
// ./src/components/operations/Inflation.js